// extracted by mini-css-extract-plugin
module.exports = {"conversation":"ConversationView_conversation__2CLdc","instructions":"ConversationView_instructions__23mE3","video":"ConversationView_video__PQM5L"};